import React from "react";


function VulscanTargetField({value, onChange}) {

    const handleChange = (value) => {
        onChange(value);
    }

    return (
        <div className="network-scan-control-v2">
                <label className="network-scan-control-label-v2" htmlFor="scanTarget">Target</label>
                <input className="network-scan-input-v2"
                  id="scanTarget"
                  type="text"
                  value={value}
                  onChange={event => handleChange(event.target.value)} />
        </div>
    );
}


export default VulscanTargetField;
